import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

function SupportLandingPage() {
  return (
    <div className="container">
      <div className="layout-container content-container content-container--column content-container--shadow">
        <div className="content-display__container content-display__container--column align-center">
          <FormattedMessage
            id="support.header"
            data-test="header-text"
            defaultMessage="Support Tools"
            description="The title for the page">
            {(txt) => (
              <h1
                className="no-margin text-deep-blue text-center"
                data-test="header-text-support">
                {txt}
              </h1>
            )}
          </FormattedMessage>
          <hr />
          <div
            className="content-display__container"
            data-test="content-container">
            <div
              className="content-display__column"
              data-test="active-unit-container">

              {/* Database Tools - Begin */}
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="support.dbTools-title"
                      data-test="support-dbTools-title"
                      defaultMessage="Database Tools"
                      description="Support Database Tools title"
                    />
                  </div>
                  <div
                    className="item-container__secondary-text text-medium text-bold"
                    data-test="user-active-unit-link">
                    <FormattedMessage
                      id="db.summary"
                      data-test="db-summary-text"
                      defaultMessage="Database tools."
                      description="summary"
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <Link
                    to="/support/db/"
                    className="link-button button-secondary button-xsm text-small margin-right-10 text-center">
                    View Tools
                  </Link>
                </div>
              </div>
              {/* Database Tools - End */}

              {/* Echostream Tools - Begin */}
              <div className="content-display__item-pill-container">
                <div className="item-container__main-container">
                  <div className="item-container__main-text text-large text-light">
                    <FormattedMessage
                      id="support.echostream-title"
                      data-test="echostream-title"
                      defaultMessage="Echostream Tools"
                      description="Support echostream title"
                    />
                  </div>
                  <div
                    className="item-container__secondary-text text-medium text-bold"
                    data-test="user-active-unit-link">
                    <FormattedMessage
                      id="support.echostream.summary"
                      data-test="echostream-summary-text"
                      defaultMessage="Echostream tools"
                      description="summary"
                    />
                  </div>
                </div>
                <div className="item-container__info-container">
                  <Link
                    to="/support/echostream/"
                    className="link-button button-secondary button-xsm text-small margin-right-10 text-center">
                    View Tools
                  </Link>
                </div>
              </div>
              {/* Echostream Tools - End */}


            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportLandingPage;
